import React from 'react';

export default function MattersPage() {
  return (
    <main style={{ fontFamily: 'Inter, sans-serif', padding: '24px' }}>
      <h1>Hello World</h1>
      <p>Matters feature shell (Phase 1E).</p>
    </main>
  );
}
